import { AnyAction } from 'redux';
import { RESET_STATE, GET_APPS, GET_APP_CATALOG, TOGGLE_NOTIFICATION, APP_CATALOG_LOADING, APPS_LOADING } from '@app/store/constants';

const initialState = {
    ssoAppsLoading: true,
    appsLoading: true,
    apps: [],
    catalogApps: [],
    showNotification: true,
};

export function launchPad(state = initialState, action: AnyAction) {
    const { payload, type } = action;

    switch (type) {
        case RESET_STATE:
            return initialState;
        case GET_APPS:
            return {
                ...state,
                apps: payload,
            };

        case GET_APP_CATALOG:
            return {
                ...state,
                catalogApps: payload,
            };

        case TOGGLE_NOTIFICATION:
            return {
                ...state,
                showNotification: !payload,
            };

        case APPS_LOADING:
            return {
                ...state,
                appsLoading: payload
            };

        case APP_CATALOG_LOADING:
            return {
                ...state,
                appCatalogLoading: payload
            };

        default:
            return state;
    }
}
